import {createContext, useContext} from 'react'

export const ENABLE_MODE__OFF = 'off'
export const ENABLE_MODE__FULL = 'full'
export const ENABLE_MODE__DISABLE = 'disable'

const LabelConfigContext = createContext({
  contextID: '',
  labelInfoID: null,
  onChange: null,
  shipperType: null,
  isLabelEnableMode: false,
  enableMode: ENABLE_MODE__OFF,
  isSummary: false,
  isPickMode: false,
  showUnSetupPackingList: true,
  showBillTo: true,
  isValueSummary: false,
})

export default LabelConfigContext

export function useLabelConfigContext() {
  return useContext(LabelConfigContext)
}
